var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:(_vm.styleRules),attrs:{"preserveAspectRatio":_vm.preserveAspectRatio,"viewBox":_vm.viewBox}},[(_vm.brandInfo)?_c('use',{attrs:{"href":_vm.logoRef}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }